import { render } from "./ReserveRoomView.vue?vue&type=template&id=54773965"
import script from "./ReserveRoomView.vue?vue&type=script&lang=js"
export * from "./ReserveRoomView.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2236819739/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__